import React from "react";
import { Link } from "react-router-dom";

import { helpPath } from "../../../teacherStore";
import { ReactComponent as Logo } from "../../../assets/svg/logo.svg";

import styles from "./Footer.module.scss";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.company}>
          <p className={styles.name}>株式会社エナジード</p>
          <p className={styles.address}>
            〒160-0015 東京都新宿区大京町22-1　グランファースト新宿御苑8F
          </p>
          <p className={styles.copyright}>©2021 ENAGEED Co.,Ltd.</p>
          <p className={styles.notice}>
            本サイトに掲載の資料動画、コンテンツは、弊社とのご契約の範囲で授業でご活用いただくためにご提供するものです。
            <br />
            ご契約の範囲を越えるご利用、上記目的外でのご利用、貴校関係者外への共有などはご遠慮ください。
            <br />
            また本サイトの一部または全部を無断で複写、複製することは法律で認められた時を除き、著作権の侵害となりますのでご注意ください。
          </p>
        </div>
        <div className={styles.support}>
          <Link className={styles.helpLink} to={helpPath}>
            ヘルプ
          </Link>
          <Logo className={styles.logo} />
        </div>
      </div>
    </div>
  );
};

export default Footer;
